import { apiRequest } from './httpClient';

// Trae el catálogo de dominios/paquetes desde 20i y lo cachea en Firestore
// (hosting_packages). No trae fecha de renovación — 20i no la expone por API.
export const syncHostingPackages = () => apiRequest('syncHostingPackages', { method: 'POST' });

export const linkHostingPackage = ({ packageId, clientId, renewalDate, billingFrequency, autoRenew, amount }) => apiRequest('linkHostingPackage', {
  body: { packageId, clientId, renewalDate, billingFrequency, autoRenew, amount },
});

export const unlinkHostingPackage = ({ packageId }) => apiRequest('unlinkHostingPackage', {
  body: { packageId },
});

// Crea/actualiza las tareas internas de las renovaciones que ya existían
// antes de activar la automatización de Agenda.
export const syncHostingRenewalTasks = () => apiRequest('syncHostingRenewalTasks', { method: 'POST' });
